/**
 * Run Stream Worker Factory
 *
 * Isolates the `import.meta.url` worker-URL construction into its own module.
 * CRA's Jest (babel-preset-react-app, CommonJS test context) can't parse
 * `import.meta`, so keeping it here lets RunStreamService be unit-tested by
 * mocking this factory — the production code path is unchanged.
 *
 * @module shared/workers/runStreamWorkerFactory
 */

export const createRunStreamWorker = () =>
  new Worker(new URL('./runStreamWorker.js', import.meta.url));
